import { Fade, Modal, SxProps, Theme, Typography } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import XClose from '@/assets/svg/ui-elements/close.svg';

import { CloseButton, ModalContent } from './styled';

type ModalProps = React.ComponentProps<typeof Modal>;

interface CustomModalProps extends ModalProps {
  centered?: boolean;
  sx?: SxProps<Theme>;
  withCloseButton?: boolean;
  title?: string;
}

const CustomModal: FC<PropsWithChildren<CustomModalProps>> = ({
  children,
  withCloseButton,
  sx,
  title,
  centered,
  open,

  ...rest
}) => {
  return (
    <Modal open={open} closeAfterTransition {...rest}>
      <Fade in={open} timeout={200}>
        <ModalContent sx={sx}>
          {title && (
            <Typography
              display={centered ? 'flex' : 'static'}
              justifyContent={centered ? 'center' : 'start'}
              variant="h5"
              fontWeight="medium"
              textAlign={centered ? 'center' : 'left'}
            >
              {title}
            </Typography>
          )}
          {withCloseButton && (
            <CloseButton
              sx={{ background: 'transparent' }}
              onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
                rest.onClose && rest.onClose(e, 'escapeKeyDown')
              }
              iconOnly
            >
              <XClose />
            </CloseButton>
          )}

          {children}
        </ModalContent>
      </Fade>
    </Modal>
  );
};

export default CustomModal;
